import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { updateJob, ensureKnown, markFeedbackRead } from '../../store/knownDataSlice';
import JobFeedbackView from '../parts/JobFeedbackView';
import QueryDetails from '../parts/QueryDetails';
import UpdateJob from '../parts/UpdateJob';
import EditQuery from '../parts/EditQuery';
import SendFeedback from '../parts/SendFeedback';
import UpdatePrice from '../parts/UpdatePrice';
import FoodPackages from '../parts/FoodPackages';
import AllNotes from '../parts/AllNotes';
import SendEmails from '../parts/SendEmails';
import PrivateNotes from '../parts/PrivateNotes';
import Section from '../../components/Section';
import SaveOfferPdf from '../parts/SaveOfferPdf';



function JobView(props) {
    const id = useParams()["id"].toUpperCase();
    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);

    useEffect(() => {
        dispatch(ensureKnown({ id }));
    }, []);



    if(!data) return;

    const currentTime = Math.floor(Date.now() / 1000);
    const queryStartTime = data["query_start"];
    const isUpcoming = queryStartTime >= currentTime;

    return (
        <div className="column g32 p32 screen center-cross">

            <div className="column g32" style={{ maxWidth: '100%' }}>

                <div className="column g8">
                    <div className="row g16 center-cross">
                        <h1>Töö</h1>
                        <SaveOfferPdf id={id} />
                    </div>

                    <h2>{JSON.parse(data["query_route"]).map(route => route["city_name"]).join(" - ")}</h2>
                </div>

                <QueryDetails id={id} />

                <FoodPackages id={id} />

                {!isUpcoming && <JobFeedbackView id={id} />}

                {!isUpcoming && (
                    <Section title="Muuda tagasisidet" initiallyHidden={true}>
                        <SendFeedback id={id} />
                    </Section>
                )}

                <UpdateJob id={id} />

                <AllNotes id={id} />

                <PrivateNotes id={id} />

                <UpdatePrice id={id} />

                <EditQuery id={id} />

                <SendEmails id={id} />

            </div>

        </div>
    );
};

export default JobView;